module.exports = __webpack_public_path__ + "img/social_friend_active.b1a5cf0c.svg";